var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('th',[_vm._v("Fnactest")]),_c('th',[_vm._v("Fnacdate")]),_c('th',[_vm._v("Fnacres")])])}
var staticRenderFns = []

export { render, staticRenderFns }